import React, { useEffect } from 'react';
import { YStack, Text, Image } from 'tamagui';

import { homeGuardianLogoFull } from '../../assets';

export const ScreenSaver: React.FC = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes dissolve { from { opacity: 0; } to { opacity: 1; } }
      @keyframes bgDissolve { from { background-color: rgba(22,22,22,0); } to { background-color: rgba(22,22,22,0.75); } }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <YStack
      flex={1}
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      style={{
        backgroundColor: 'rgba(22,22,22,0)',
        animation: 'bgDissolve 1000ms ease-in forwards',
      }}>
      <YStack
        alignItems="center"
        style={{
          opacity: 0,
          animation: 'dissolve 1000ms ease-in forwards',
        }}>
        <Image
          source={{ uri: homeGuardianLogoFull }}
          alt="Home Guardian Logo"
          width={557.5}
          height={200}
          resizeMode="contain"
        />
        <Text
          fontFamily="$heading"
          fontSize="$2"
          fontWeight="$5"
          color="$white10"
          textAlign="center"
          marginTop={64}>
          Tap to Continue
        </Text>
      </YStack>
    </YStack>
  );
};
